import { GET_PROFILE, LOGIN, LOGOUT, UPDATE_PROFILE } from '~/store/actions/UserAction/type';

// console.log("localStorage.getItem('userInfo'): ", localStorage.getItem('userInfo'));
const initState = {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
};

const UserReducer = (state = initState, action) => {
    switch (action.type) {
        case LOGIN: {
            const newUserInfo = action.payload;
            return {
                ...state,
                userInfo: newUserInfo,
            };
        }

        case LOGOUT: {
            return {
                ...state,
                userInfo: {},
            };
        }

        case GET_PROFILE: {
            const newUserInfo = action.payload;
            return {
                ...state,
                userInfo: newUserInfo,
            };
        }
        case UPDATE_PROFILE:
            {
            }
            const newUserInfo = action.payload;
            return {
                ...state,
                userInfo: newUserInfo,
            };

        default:
            return state;
    }
};

export default UserReducer;
